import {
    Acc
} from './accordion.js'; //アコーディオン

export class Dmenu {
    constructor() {
        this.body = {}
        this.html = {}
        this.menuCheckBox = {}
        this.spSubMenuScrollContainer = {}
        this.checked = false
        this.pcBuyBtn = {}
        this.accordions = {}
    }

    spSubMenuClicked() {
        // サブメニューを閉じる機能 (ドロワーメニュー内のリンクやXボタンなどを押した場合に)
        //this.checked = false;
        this.body.classList.remove('Drawer-sp__opening');

        this.menuCheckBox.checked = false;
    }

    init() {
        this.body = document.getElementsByTagName('body')[0];
        this.html = document.getElementsByTagName('html')[0];
        this.menuCheckBox = document.getElementById('Drawer-menu__trigger');
        this.spSubMenuScrollContainer = document.getElementById('Drawer-menu__scroll-container');

        if (document.getElementById('Drawer-menu__trigger')) {
            // チェックボックス変更時
            this.menuCheckBox.addEventListener('change', () => { //定義時のthisの値を拘束
                //console.log('menu trigger changed: ' + this.checked);
                //let scrollpos = window.scrollY || window.pageYOffset;//スクロール位置を保存

                if (this.body.classList.contains('Drawer-sp__opening')) {
                    //ドロワーメニュー閉じる
                    this.body.classList.remove('Drawer-sp__opening');
                    this.body.classList.add('Drawer-menu-closing');

                    //ドロワーメニュー閉じた後
                    var _this = this;
                    window.setTimeout(function () {
                        _this.body.classList.remove('Drawer-menu-closing');
                        _this.body.classList.add('Drawer-menu-closed');
                    }, 400);
                } else {
                    //ドロワーメニュー開く
                    this.body.classList.remove('Drawer-menu-closed');
                    this.body.classList.add('Drawer-sp__opening');
                }
            });


            //aタグの場合
            this.spSubMenuLinkElems = this.spSubMenuScrollContainer.querySelectorAll('a:not(.js-accordion-btn)');
            [].forEach.call(this.spSubMenuLinkElems, (elem) => {
                elem.addEventListener('click', () => { //定義時のthisの値を拘束
                    this.spSubMenuClicked();
                });
            });

            //overlayの場合
            // this.overlayElm = document.getElementById('overlay');
            // this.overlayElm.addEventListener(APP._click, () => {//定義時のthisの値を拘束
            //     console.log('overlay-clicked');
            //     this.spSubMenuClicked();
            // });

            //PC購入ボタン
            // if (document.querySelectorAll('.js-pulldown-container')[0]) {
            //     this.pcBuyBtn = document.querySelectorAll('.js-pulldown-container')[0];
            //     this.pcBuyBtn.addEventListener('click', () => {
            //         this.pcBuyBtn.classList.toggle('is-pulldown-open');
            //     });
            // }

            //submenu accordion
            this.accordions = new Acc();
            this.accordions.init();
        }

    }

    removeListener() {
        // addEventListener が重複して登録される https://qiita.com/yuki153/items/c909c54204eaab6ca1b2

    }



}